import type IBasketAccount from "@modules/order/stores/models/IBasketItem.models";
import { create } from "zustand";

interface BuyModalStore {
  account: IBasketAccount | undefined;
  isOpened: boolean;
  open: (account: IBasketAccount, onBuy?: (isBuyNow: boolean) => void) => void;
  close: () => void;
  onBuy?: (isBuyNow: boolean) => void;
}

const useBuyModalStore = create<BuyModalStore>()((set) => ({
  account: undefined,
  isOpened: false,
  onBuy: undefined,
  open: (account, onBuy) => set({ onBuy, account, isOpened: true }),
  close: () => {
    set({ isOpened: false });
    setTimeout(() => set({ account: undefined }), 150);
  },
}));

export default useBuyModalStore;
